import React, { useState, useEffect, useContext } from "react";
import Year, { IYear } from "../../../services/api/Year";
import AuthContext from "../../../contexts/AuthContext";
import YearList from "./YearList";
import Form from "./Form";

const Years: React.FC = () => {
  const { user } = useContext(AuthContext);
  const [years, setYears] = useState<IYear[]>([]);
  const readOnly = user!.profile.name === "Viewer";

  async function LoadYears() {
    const response: IYear[] = await Year.GetAll();
    setYears(response);
  }

  useEffect(() => {
    LoadYears();
  }, []);

  function toggleForm(e: any) {
    e.target.nextElementSibling.classList.toggle("form--open");
    e.target.parentNode.parentNode.parentNode.parentNode.classList.toggle(
      "form--open"
    );
  }

  return (
    <React.Fragment>
        <section className="content__block">
            <div className="content__header">
                <h2 className="content__title">Available years</h2>
                <div className="multi-selects">
                    <div className="content__select">
                        <button
                            disabled={readOnly}
                            onClick={toggleForm}
                            className="button button--blue button--icon button--add"
                        >
                            Add New
                        </button>
                        <div className="form--float">
                            <Form year={{} as IYear} />
                        </div>
                    </div>
                </div>
            </div>
                    <div className="groups edit__buttons">
                        <YearList years={years} />
                    </div>
        </section>
    </React.Fragment>
  );
};

export default Years;
